import React, { useState, useContext, useEffect } from 'react';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';

import emailjs from '@emailjs/browser';
import { DataContext } from './../App';

export default function Identity(params) {
  const {
    page,
    type,
    grundstucktyp,
    flache,
    grundstuck,
    anzahlDerEinheiten,
    selectedYear,
    zustandDerImmobilie,
    derzeitigeNutzung,
    anzahlDerZimmer,
    gartenBalkon,
  } = useContext(DataContext);

  let [data, setData] = useState({
    anrede: 'Herr',
    zweck: 'Ich möchte verkaufen',
    datenschutz: false,
  });
  const [emailSent, setEmailSent] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [validated, setValidated] = useState(false);

  useEffect(() => {
    setValidated(
      (true &&
        data.vorname &&
        data.nachname &&
        data.email &&
        data.telefonnummer &&
        data.plz &&
        data.datenschutz) ??
        false
    );
  }, [data]);

  const returnTemplateId = (page) => {
    switch (page) {
      case 'GRUNDSTÜCK':
        return 'template_4n1wp29';
      default:
        return 'template_owa30u8';
    }
  };
  let handleChange = (e, type) => {
    data[type] = e.target.value;
    setData({ ...data });
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    setSubmitted(true);
    const paramsToSubmit = {
      ...data,
      page,
      type,
      grundstucktyp,
      flache,
      grundstuck,
      anzahlDerEinheiten,
      selectedYear,
      zustandDerImmobilie,
      derzeitigeNutzung,
      anzahlDerZimmer,
      gartenBalkon,
    };
    paramsToSubmit.anzahlText =
      page === 'MEHRFAMILIENHAUS'
        ? 'Anzahl der Einheiten'
        : 'Anzahl der Zimmer';
    paramsToSubmit.anzahlValue =
      page === 'MEHRFAMILIENHAUS' ? anzahlDerEinheiten : anzahlDerZimmer;

    paramsToSubmit.grundstuckGartenBalkonText =
      page === 'WOHNUNG' ? 'Garten / Balkon' : 'Grundstück';
    paramsToSubmit.grundstuckGartenBalkonValue =
      page === 'WOHNUNG' ? gartenBalkon : grundstuck + 'm²';

    emailjs
      .send(
        'service_kt3qbsi',
        returnTemplateId(page),
        paramsToSubmit,
        '9a3P78tCmuiUj0_bA'
      )
      .then(
        (result) => {
          setEmailSent(true);
        },
        (error) => {
          // show the user an error
        }
      )
      .finally(() => setSubmitted(false));
  };

  return (
    <>
      <>
        <h2>
          <strong>
            {emailSent ? 'VIELEN DANK' : 'WER SOLL DIE BEWERTUNG ERHALTEN?'}
          </strong>
          <hr />
        </h2>
        {emailSent ? (
          <div>
            Die E-Mail wurde gesendet. Wir werden uns sehr bald mit Ihnen in
            Verbindung setzen.
          </div>
        ) : (
          <>
            <Form className='identity' noValidate onSubmit={null}>
              <Row>
                <Form.Group
                  as={Col}
                  md='3'
                  className='mb-3'
                  controlId='validationCustomUsername'
                >
                  <Form.Label>Anrede</Form.Label>
                  <Form.Select
                    value={data.anrede}
                    onChange={(e) => handleChange(e, 'anrede')}
                    aria-label='Default select example'
                  >
                    <option value='Herr'>Herr</option>
                    <option value='Frau'>Frau</option>
                    <option value='Divers'>Divers</option>
                  </Form.Select>
                </Form.Group>
              </Row>
              <Row>
                <Form.Group
                  as={Col}
                  className='mb-3'
                  md='6'
                  controlId='validationCustom01'
                >
                  {/* <Form.Label>Vorname</Form.Label>*/}
                  <Form.Control
                    value={data.vorname}
                    onChange={(e) => handleChange(e, 'vorname')}
                    required
                    type='text'
                    placeholder='Vorname'
                  />
                  <Form.Control.Feedback type='invalid'>
                    Bitte Ihren Vorname eintragen
                  </Form.Control.Feedback>
                </Form.Group>
                <Form.Group
                  as={Col}
                  className='mb-3'
                  md='6'
                  controlId='validationCustom02'
                >
                  {/* <Form.Label>Nachname</Form.Label>*/}
                  <Form.Control
                    value={data.nachname}
                    onChange={(e) => handleChange(e, 'nachname')}
                    required
                    type='text'
                    placeholder='Nachname'
                  />
                  <Form.Control.Feedback type='invalid'>
                    Bitte Ihren Nachname eintragen
                  </Form.Control.Feedback>
                </Form.Group>
              </Row>

              <Row>
                <Form.Group
                  as={Col}
                  className='mb-3'
                  md='6'
                  controlId='validationCustom01'
                >
                  <Form.Label>E-MAIL</Form.Label>
                  <Form.Control
                    value={data.email}
                    onChange={(e) => handleChange(e, 'email')}
                    required
                    type='email'
                    placeholder='Ihre Email'
                  />
                  <Form.Control.Feedback type='invalid'>
                    Bitte eine gültige E-Mail eintragen
                  </Form.Control.Feedback>
                </Form.Group>
                <Form.Group
                  as={Col}
                  className='mb-3'
                  md='6'
                  controlId='validationCustom02'
                >
                  <Form.Label>Telefonnummer</Form.Label>
                  <Form.Control
                    value={data.telefonnummer}
                    onChange={(e) => handleChange(e, 'telefonnummer')}
                    required
                    type='text'
                    placeholder='Ihre Nummer'
                  />
                  <Form.Control.Feedback type='invalid'>
                    Bitte eine gültige Nummer eintragen
                  </Form.Control.Feedback>
                </Form.Group>
              </Row>
              <div className='agreement'>
                <Row>
                  <Form.Label>
                    In welcher Region befindet sich die Immobilie?
                  </Form.Label>
                  <Form.Group
                    as={Col}
                    className='mb-3'
                    md='4'
                    controlId='validationCustom03'
                  >
                    <Form.Control
                      value={data.plz}
                      onChange={(e) => handleChange(e, 'plz')}
                      type='text'
                      placeholder='PLZ'
                      required
                    />
                    <Form.Control.Feedback type='invalid'>
                      Bitte geben Sie eine gültige Postleitzahl ein.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Row>
                <Row>
                  <Form.Group as={Col} md='12'>
                    <Form.Label>
                      Wofür benötigen Sie den Wert der Immobilie?
                    </Form.Label>
                    <Form.Select
                      value={data.zweck}
                      onChange={(e) => handleChange(e, 'zweck')}
                      aria-label='Default select example'
                    >
                      <option value='Ich möchte verkaufen'>
                        Ich möchte verkaufen
                      </option>
                      <option value='Ich möchte kaufen'>
                        Ich möchte kaufen
                      </option>
                      <option value='Ich bin neugierig'>
                        Ich bin neugierig
                      </option>
                    </Form.Select>
                  </Form.Group>
                </Row>
              </div>
              <Row className='mb-3'>
                <div className='agreement-box'>
                  <Form.Group as={Col} md='12'>
                    <Form.Check
                      value={!JSON.parse(data.datenschutz)}
                      type='radio'
                      checked={JSON.parse(data.datenschutz) === true}
                      onChange={(e) => handleChange(e, 'datenschutz')}
                      className='datenschutz'
                      id='datenschutz'
                      required
                      feedback='Bitte stimmen Sie der Datenschutzerklärung zu.'
                      feedbackType='invalid'
                    />
                    <label className='datenschutz' htmlFor='datenschutz'>
                      &nbsp; ICH WILLIGE ZUR KONTAKTAUFNAHME UND ZUSENDUNG VON
                      INFORMATIONEN EIN. WEITERE ANGABEN, AUCH ZU MEINEM
                      WIDERRUFSRECHT, HABE ICH IN DER{' '}
                      <a
                        target='_blank'
                        href='https://propertyimmobilien.de/property-immobilien/datenschutzerklaerung/'
                        rel='noreferrer'
                      >
                        DATENSCHUTZERKLÄRUNG
                      </a>{' '}
                      GELESEN.
                    </label>
                  </Form.Group>
                </div>
              </Row>
              <div className='agreement'>
                <label>100 % KOSTENLOS & UNVERBINDLICH!</label>
              </div>
            </Form>
            <div className='buttons'>
              <button className='previous' onClick={params.previousPage}>
                Zurück
              </button>
              <button
                type='submit'
                className='next'
                disabled={submitted || !validated}
                style={{
                  cursor: submitted || !validated ? 'not-allowed' : 'pointer',
                }}
                onClick={handleSubmit}
              >
                {submitted ? '...' : 'ABSENDEN'}
              </button>
            </div>
          </>
        )}
      </>
    </>
  );
}
